import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as moment from 'moment';
import { openDiaryTitle, noteFilterConstants } from "../../../../containers/WorkkardDetail/constants";
import * as CommonUtil from "../../../../common/util";
import MultiOptionFilter from '../../MiddlePanelContainer/Filter/multiOptionFilter';
import {ActivityTitleFilterLoader,RoundImageLoader,DateFilterLoader,ContentFilterLoader} from '../../../../components/SkeletonLoader';
import {
  getUsersFilteredData,
  getActivityTitleFilteredData,
  getDateFilteredData,
  getSettingsFilteredData,
  updatedeselectednotetemplates,
  savedeselectednotetemplates,
  fetchCombinedViewData
} from "../../../../containers/WorkkardDetail/actions/action";
import DatePicker from '../../../../components/DatePicker';
import { DEFAULT_TIME_FORMAT } from '../../../../common/constants';
import ContentFilter from './tableFilter';
import CheckBox from '../../../../components/Checkbox';
import Icon from "../../../../icons";

export default function Filter() {
  const dispatch = useDispatch();
  const combinedViewFilters = useSelector(state => state.workkardDetail.combinedView.filters);
  const combinedViewSettings = useSelector(state => state.workkardDetail.combinedView.settings);
  const noteFilters = useSelector(state => state.workkardDetail.middlePanel.activityNoteTemplates);
  const excludedFilters = useSelector(state => state.workkardDetail.combinedView.cvExcludedFilters);
  const workkardid = useSelector(state => state.workkardDetail.workkardDetail.Id);
  const orgid = useSelector(state => state.sessionContextOidc.organizationView?.Id);
  const usersList = useSelector(state => state.userList);

  const [userFilter, setUserFilter] = useState(false);
  const [activityTitleFilter, setActivityTitleFilter] = useState(false);
  const [contentFilterCheckboxValues, setContentFilterCheckboxValues] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userFilterOption, setUserFilterOption] = useState({});
  const [activityTitleFilterOption, setActivityTitleFilterOption] = useState({});
  const [activityNoteFilter, setActivityNoteFilter] = useState(false);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [allNoteFilters, setAllNoteFilters] = useState([]);
  const [selectedNoteFilters, setSelectedNoteFilters] = useState([]);
  const [deselectedNoteTemplates, setDeselectedNoteTemplates] = useState([]);
  const [allNoteTemplateSelected, setAllNoteTemplateSelected] = useState(false);

  const excludedFiltersValuesRef = useRef([]);
  const distinctexcludedFiltersValuesRef = useRef([]);
  const filterRef = useRef(null);
  const endDateCalendarRef = useRef(null);
  const startDateCalendarRef = useRef(null);

  // Refs to mirror state for event handler (avoids stale closures)
  const allNoteFiltersRef = useRef([]);
  const deselectedNoteTemplatesRef = useRef([]);
  const activityNoteFilterRef = useRef(false);
  const selectedActivitiesRef = useRef([]);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const allNoteTemplateSelectedRef = useRef(false);

  // Keep refs in sync with state on every render
  allNoteFiltersRef.current = allNoteFilters;
  deselectedNoteTemplatesRef.current = deselectedNoteTemplates;
  activityNoteFilterRef.current = activityNoteFilter;
  selectedActivitiesRef.current = selectedActivities;
  startDateRef.current = startDate;
  endDateRef.current = endDate;
  allNoteTemplateSelectedRef.current = allNoteTemplateSelected;

  // componentDidMount: event listener + initial state
  useEffect(() => {
    const handler = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        let initalFilters = [];
        allNoteFiltersRef.current.forEach((item) => {
          if (deselectedNoteTemplatesRef.current.find((ele) => ele.id == item.id) == null) {
            item.checked = true;
            initalFilters.push(item);
          } else {
            item.checked = false;
            initalFilters.push(item);
          }
        });
        let isAllChecked = initalFilters.some((element) => !element.checked);
        setActivityNoteFilter(!activityNoteFilterRef.current);
        setAllNoteTemplateSelected(!isAllChecked);
        setAllNoteFilters(initalFilters);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // combinedViewSettings changes (mount + update)
  useEffect(() => {
    if (combinedViewSettings) {
      setContentFilterCheckboxValues({
        WorkkardNotes: combinedViewSettings.WorkkardNotes,
        ActivityNotes: combinedViewSettings.ActivityNotes,
        WorkkardLogs: combinedViewSettings.WorkkardLogs,
        ActivityLogs: combinedViewSettings.ActivityLogs,
        WorkkardActions: combinedViewSettings.WorkkardActions,
        ActivityActions: combinedViewSettings.ActivityActions,
        WorkkardFiles: combinedViewSettings.WorkkardFiles,
        ActivityFiles: combinedViewSettings.ActivityFiles,
      });
    }
  }, [combinedViewSettings]);

  const isFiltersFirstRenderRef = useRef(true);
  useEffect(() => {
    if (combinedViewFilters) {
      const { users, activityTitle } = combinedViewFilters;
      const filteredUsers = users?.map(item => usersList[item.UserId]).filter(Boolean);
      const usersFilter = {
        AllUsers: {
          name: 'Users', value: '0', checked: false,
          options: filteredUsers?.map((item, key) => {
            return {
              name: `${item?.first_name} ${item?.last_name}`, 
              value: item?.id, 
              checked: false, 
              userImage: item?.profile_image
            }
          })
        }
      }
      const activityTitleFilterData = {
        All: {
          name: 'Activities', value: '1', checked: false,
          options: activityTitle?.map((item) => {
            const title = item?.title;
            const name = title && title.length > openDiaryTitle.maxLengthToTruncate
              ? title.substring(openDiaryTitle.startIndexOfSubstringTruncate, openDiaryTitle.endIndexOfSubstringTruncate) + "..."
              : title;
            return {
              name,
              value: item?.id,
              checked: false,
              title
            }
          })
        }
      }
      setUserFilterOption(usersFilter);
      setActivityTitleFilterOption(activityTitleFilterData);
    }

    if (isFiltersFirstRenderRef.current) {
      isFiltersFirstRenderRef.current = false;
      return;
    }

    // isignored flag is introduced to prevent duplicate call for cvp data need to fix later
    if (Object.keys(combinedViewFilters).length > 0 && !(combinedViewFilters.isIgnore || combinedViewFilters.isIgnore == undefined)) {
      const payload = {
        id: workkardid,
        start: 0,
        end: 50,
        fetchdata: true
      };
      dispatch(fetchCombinedViewData(payload));
    }
    if (Object.keys(combinedViewFilters).length > 0 && combinedViewFilters.activityTitle.length > 0 && Object.keys(noteFilters).length > 0 && noteFilters && allNoteFiltersRef.current.length == 0) {
      fetchNoteTypeData(noteFilters, excludedFilters, combinedViewFilters, orgid, "cvload");
    }
  }, [combinedViewFilters, noteFilters]);

  const getDeselectedNoteTemplateId = (currentAllNoteFilters, currentAllNoteTemplateSelected) => {
    let isAllDeselected = currentAllNoteFilters.every(x => !x.checked);
    const payload = { dntids: excludedFiltersValuesRef.current.join(","), showAllTemplates: currentAllNoteTemplateSelected || isAllDeselected };
    dispatch(updatedeselectednotetemplates(payload));
  }

  const getDataBasedOnUsers = (payload) => {
    dispatch(getUsersFilteredData(payload));
  }

  const onApplyUsersFilter = (data) => {
    const checkedFields = data.AllUsers.options.filter(item => item.checked == true);
    let payload;
    if (checkedFields.length == 0) {
      const { users } = combinedViewFilters;
      payload = { sdate: startDate ? startDate.split(',')[0] : '', edate: endDate ? endDate.split(',')[0] : '', users: users?.map((item) => item.UserId), start: 0, end: 50 }
    } else {
      payload = { sdate: startDate ? startDate.split(',')[0] : '', edate: endDate ? endDate.split(',')[0] : '', users: checkedFields.map((item) => item.value), start: 0, end: 50 }
    }
    getDataBasedOnUsers(payload);
  }

  const onApplyActivityTitleFilter = (data) => {
    const checkedFields = data.All.options.filter(item => item.checked == true);
    let payload;
    if (checkedFields.length == 0) {
      const { activityTitle } = combinedViewFilters;
      payload = { sdate: startDate ? startDate.split(',')[0] : '', edate: endDate ? endDate.split(',')[0] : '', activityTitle: activityTitle?.map((item) => item.id), start: 0, end: 50 }
    } else {
      payload = { sdate: startDate ? startDate.split(',')[0] : '', edate: endDate ? endDate.split(',')[0] : '', activityTitle: checkedFields.map((item) => item.value), start: 0, end: 50 };
    }
    const newSelectedActivities = payload.activityTitle;
    selectedActivitiesRef.current = newSelectedActivities;
    setSelectedActivities(newSelectedActivities);
    fetchNoteTypeData(noteFilters, excludedFilters, combinedViewFilters, orgid, "activitytitle");
  }

  const getDataBasedOnDates = (newStartDate, newEndDate) => {
    const payload = {
      sdate: newStartDate ? newStartDate.split(',')[0] : '',
      edate: newEndDate ? newEndDate.split(',')[0] : '',
      start: 0,
      end: 50
    }
    dispatch(getDateFilteredData(payload));
  }

  const handleStartDateChange = (sd) => {
    const newStartDate = sd ? moment(sd).format(DEFAULT_TIME_FORMAT) : "";
    setStartDate(newStartDate);
    getDataBasedOnDates(newStartDate, endDate);
  }

  const handleEndDateChange = (ed) => {
    const newEndDate = ed ? moment(ed).format(DEFAULT_TIME_FORMAT) : "";
    setEndDate(newEndDate);
    getDataBasedOnDates(startDate, newEndDate);
  }

  const handleClearDatePicker = () => {
    setStartDate('');
    setEndDate('');
    getDataBasedOnDates('', '');
  }

  const getSettingsFilteredDataFn = (payload) => {
    dispatch(getSettingsFilteredData(payload));
  }

  const fetchSelectedNoteTemplateData = (updatecv, noteFiltersParam, excludedFiltersParam, combinedViewFiltersParam, action, currentAllNoteFilters) => {
    let selectedTemplates = [], deselected_note_templates = [], userTemplatearr = [], dntids = [];
    let notesFilter = {};
    combinedViewFiltersParam = combinedViewFiltersParam || combinedViewFilters;
    noteFiltersParam = noteFiltersParam || noteFilters;
    excludedFiltersParam = excludedFiltersParam || excludedFilters;
    selectedTemplates = getSelectedActivityTemplates(selectedTemplates, combinedViewFiltersParam);
    const currentFilters = currentAllNoteFilters !== undefined ? currentAllNoteFilters : allNoteFiltersRef.current;
    const deselectedNoteTemplatesLocal = currentFilters.filter(element => { return !element.checked });
    let deselectedTemplatesName = deselectedNoteTemplatesLocal.map((e) => e.label);
    Object.keys(noteFiltersParam).forEach((data) => {
      if (selectedTemplates.includes(data)) {
        let notetemplateshortnames = noteFiltersParam[data].map(x => x.TemplateShortName);
        let unrelatedactnotetemplates = excludedFiltersParam[data]?.filter(e => !notetemplateshortnames.includes(e));
        deselected_note_templates = noteFiltersParam[data]
          .filter((ele) => {
            if (ele.IsSystem) {
              return deselectedTemplatesName.includes("System Note");
            } else {
              return deselectedTemplatesName.includes(ele.NoteTemplateName);
            }
          });
        dntids = dntids.concat(deselected_note_templates.map((x) => x.Id));
        let deselectedshortnames = deselected_note_templates.map((x) => x.TemplateShortName).filter((value, index, array) => array.indexOf(value) === index);
        userTemplatearr.push({
          activity_template_id: data,
          deselected_note_template_ids: deselectedshortnames,
        });
        notesFilter[data] = deselectedshortnames;
      }
    });
    dntids = dntids.filter((value, index, array) => array.indexOf(value) === index);
    let payload = {
      updateFiltersAPI: {
        data: userTemplatearr,
        origin: noteFilterConstants.CombineView,
      },
      notesFilter: notesFilter
    };
    excludedFiltersValuesRef.current = dntids;
    if (updatecv) {
      getDeselectedNoteTemplateId(currentFilters, allNoteTemplateSelectedRef.current);
    } else {
      dispatch(savedeselectednotetemplates(payload));
      getDeselectedNoteTemplateId(currentFilters, allNoteTemplateSelectedRef.current);
      setSelectedNoteFilters(currentFilters.filter((e) => e.checked));
      setDeselectedNoteTemplates(deselectedNoteTemplatesLocal);
      action = "cvload";
    }
    //for all unselected filters then call for select all
    let deselectedAll = currentFilters.every(x => !x.checked);
    const cvpayload = {
      activityTitle: selectedActivitiesRef.current,
      sdate: startDateRef.current ? startDateRef.current.split(',')[0] : '',
      edate: endDateRef.current ? endDateRef.current.split(',')[0] : '',
      start: 0,
      end: 50,
      dntids: deselectedAll ? [] : dntids,
      id: workkardid,
      fetchdata: true
    }
    switch (action) {
      case "activitytitle":
        dispatch(getActivityTitleFilteredData(cvpayload));
        break;
      case "cvload":
        dispatch(fetchCombinedViewData(cvpayload));
      default:
        break;
    }
  }

  const handleCheckboxChange = (item, selectall) => {
    let ModifiedNoteFilters = [...allNoteFilters];
    if (item == null) {
      ModifiedNoteFilters.forEach((e) => (e.checked = selectall));
    } else {
      let currentItem = ModifiedNoteFilters.find(element => element.label === item.label);
      currentItem.checked = !currentItem.checked;
    }
    let isAllChecked = ModifiedNoteFilters.some((element) => !element.checked);
    setAllNoteFilters(ModifiedNoteFilters);
    setAllNoteTemplateSelected(!isAllChecked);
  }

  const getSelectedActivityTemplates = (selectedTemplates, cvFilters) => {
    const { activityTitle } = cvFilters;
    if (selectedActivitiesRef.current.length == 0) {
      selectedTemplates = activityTitle?.map((item) => item.template_short_name)
    } else {
      selectedTemplates = activityTitle?.filter((item) => selectedActivitiesRef.current.includes(item.id)).map(e => e.template_short_name)
    }
    return selectedTemplates;
  }

  const fetchNoteTypeData = (noteFiltersParam, excludedFiltersParam, cvFilters, orgidParam, action) => {
    let selectedTemplates = [], initalFilters = [], excludedFiltersValues = [], noteFiltersValues = [];

    selectedTemplates = getSelectedActivityTemplates(selectedTemplates, cvFilters);
    excludedFiltersValues = CommonUtil.getUniqueTemplates(excludedFiltersParam, selectedTemplates, excludedFiltersValues);
    const distinctexcludedFiltersValues = excludedFiltersValues.filter((value, index, array) => array.indexOf(value) === index);
    noteFiltersValues = CommonUtil.getUniqueTemplates(noteFiltersParam, selectedTemplates, noteFiltersValues);
    // var distinctfilters = noteFiltersValues.flat().filter((a, i) => noteFiltersValues.flat().findIndex((s) => a.Id === s.Id) === i).sort((a, b) => a.NoteTemplateName.localeCompare(b.NoteTemplateName));
    const systemNotesArr = noteFiltersValues.filter(ele => ele.IsSystem && ele.OrganizationId == orgidParam);
    noteFiltersValues = noteFiltersValues.filter((ele) => !ele.IsSystem).sort((a, b) => a.NoteTemplateName.localeCompare(b.NoteTemplateName));;
    let isSystemChecked = true;
    if (systemNotesArr.length > 0) {
      systemNotesArr.forEach(element => {
        let sysnotecount = systemNotesArr.filter((ele) => ele.NoteTemplateName == element.NoteTemplateName && ele.Id == element.Id).length;
        let excludedfiltercount = excludedFiltersValues.filter(ele => ele == element.TemplateShortName).length;
        if (sysnotecount == excludedfiltercount && distinctexcludedFiltersValues.includes(element.TemplateShortName)) {
          isSystemChecked = false;
        } else {
          isSystemChecked = true;
        }
      })
      initalFilters.push({ id: 0, label: "System Note", checked: isSystemChecked, IsSystem: true });
    }
    noteFiltersValues.forEach(element => {
      let checkDuplicates = initalFilters.find((item) => item.label == element.NoteTemplateName && !element.IsSystem);
      let isChecked = true;
      let notecount = noteFiltersValues.filter((ele) => ele.NoteTemplateName == element.NoteTemplateName && ele.OrganizationId == orgidParam && !ele.IsSystem).length;
      let excludedfiltercount = excludedFiltersValues.filter((ele) => ele == element.TemplateShortName).length;
      if ((notecount == excludedfiltercount && distinctexcludedFiltersValues.includes(element.TemplateShortName)) || (notecount == 0 && excludedfiltercount != 0)) {
        isChecked = false;
      }
      if (checkDuplicates != null) {
        if (isChecked) {
          checkDuplicates.checked = isChecked;
        }
      } else {
        initalFilters.push({ id: element.Id, label: element.NoteTemplateName, checked: isChecked, IsSystem: element.IsSystem })
      }
    });
    const deselectedNoteTemplatesLocal = initalFilters.filter(element => { return !element.checked });
    distinctexcludedFiltersValuesRef.current = distinctexcludedFiltersValues;

    let isAllChecked = initalFilters.some((element) => !element.checked);
    const newAllNoteTemplateSelected = !isAllChecked;

    // Update refs before calling fetchSelectedNoteTemplateData so it sees fresh values
    allNoteFiltersRef.current = initalFilters;
    allNoteTemplateSelectedRef.current = newAllNoteTemplateSelected;

    setAllNoteFilters(initalFilters);
    setAllNoteTemplateSelected(newAllNoteTemplateSelected);
    setSelectedNoteFilters(initalFilters.filter(e => e.checked));
    setDeselectedNoteTemplates(deselectedNoteTemplatesLocal);

    fetchSelectedNoteTemplateData(true, noteFiltersParam, excludedFiltersParam, cvFilters, action, initalFilters);
  }

  const renderNoteTemplates = () => {
    return allNoteFilters.map((item) => (
      <li key={item.id}>
        <a>
          <CheckBox item={item} handleCheckbox={() => handleCheckboxChange(item, false)}/>
          {item.label == "System Note" && <span class="quickTooltip-bottom" data-quicktooltip="This is a set of system-generated notes like Activity reopen, reassignment, closure, etc.">
          <Icon name="info" className="icon ml greyInfoIcon" />
          </span>}
        </a>
      </li>
    ));
  }

  const toggleNoteTypePanel = () => {
    const newActivityNoteFilter = !activityNoteFilter;
    setActivityNoteFilter(newActivityNoteFilter);
    if (allNoteFilters.length == 0) {
      fetchNoteTypeData(noteFilters, excludedFilters, combinedViewFilters, orgid);
    }
  }

  let isCVLoaded = Object.keys(combinedViewFilters).length > 0;

  return (
    <div className="cardScroll scrollArea scrollCombinedFilter animated fast fadeIn">
      <div className="combinedViewFilter">
        <div className="combinedAllFilter animated superFaster pushUpSmall combinedSeparate">
        {
          Object.keys(combinedViewSettings).length < 1 ?
          <ContentFilterLoader/>
          :
          <ContentFilter startDate={startDate} endDate={endDate} settings={combinedViewSettings} getSettingsFilteredData={(payload) => getSettingsFilteredDataFn(payload)}/>
        }
        </div>

          <div className="combinedActFilter mt__1 animated faster pushUpSmall combinedSeparate">
          {
            Object.keys(combinedViewFilters).length < 1 ?
              <ActivityTitleFilterLoader/>
            :
              activityTitleFilterOption?.All?.options && 
              <MultiOptionFilter 
                filterOptions={activityTitleFilterOption} 
                onClose={() => setActivityTitleFilter(false)} 
                showHeader={false} 
                onCheckChange={onApplyActivityTitleFilter} 
                isOnlyOption={true} 
                isParentCheckIcon={true}
              />
          }
          </div>
          { isCVLoaded && Object.keys(noteFilters || {}).length > 0 && <div className="combinedDateFilter mt__1 combinedSeparate">
            <div className='notesTypeFilter'>
              <div className='dropDown overlap filter colFlex'>
                <div className='alignMiddle rowFlex rowSpaceBetween'>
                  <h3 className="mb__8 rowFlex">Note Type</h3>
                  <a className="linkSmall pointer" onClick={() => toggleNoteTypePanel()}>{selectedNoteFilters.length > 0 ? "edit" : "add"}</a>
                </div>
                {
                  activityNoteFilter && <div className='dropDownMenu overlap animated faster pushUpSmall filter onClick noteType' ref={(node) => { filterRef.current = node }}>
                    <header className="alignMiddle stickyType rowSpaceBetween"><label>Show Note Types</label> <a onClick={() => handleCheckboxChange(null, !allNoteTemplateSelected)}>{allNoteTemplateSelected ? "unselect all" : "select all"}</a></header>
                    <ul className='colFlex'>
                      {noteFilters && renderNoteTemplates()}
                    </ul>
                    <footer className='stickyType'><div className='actions alignRight'><a className='btn link' onClick={() => { setActivityNoteFilter(!activityNoteFilter); fetchSelectedNoteTemplateData(); }}>Save</a></div></footer>
                  </div>
                }
                {
                  selectedNoteFilters.length > 0 && <div className='noteTag'>
                  <div className='tagCollaps'>
                    <ul className="rowFlex flexWrap">
                        {selectedNoteFilters.map((item) => <li key={item.id}>{item.label}</li>)}
                    </ul>
                  </div>
                  {/* {selectedNoteFilters.length > 5 && <a className='expandCollaps pointer' onClick={() => setShowless(!showless)}>{selectedNoteFilters.length - 5} more</a>} */}
                </div>
                }
              </div>
            </div>
          </div>
          }
          {/* <div className="combinedDateFilter mt__1 animated fast pushUpSmall combinedSeparate">
            {
              Object.keys(combinedViewFilters).length<1?
              <DateFilterLoader/>
              :
              <React.Fragment>
                <div className="alignMiddle rowFlex rowSpaceBetween">
                  <h3 className="mb__8 rowFlex">Date</h3>
                  <a className={(startDate || endDate)?"linkSmall":"linkSmall disabled"} href="javascript:void(0)" onClick={handleClearDatePicker}>clear</a>
                </div>
              <ul className="rowFlex">
                  <li>
                    <DatePicker
                        ref={startDateCalendarRef}
                        onChange={handleStartDateChange}
                        selectedDate={startDate}
                        placeholderText = {'Start Date'}
                        showCalenderIcon ={true}
                        openToDate={moment()}
                        maxDate={moment()}
                        shouldCloseOnSelect={true}
                    />
                  </li>
                  <li className='ml'>
                    <DatePicker
                        ref={endDateCalendarRef}
                        onChange={handleEndDateChange}
                        selectedDate={endDate}
                        placeholderText = {'End Date'}
                        showCalenderIcon ={true}
                        openToDate={moment()}
                        maxDate={moment()}
                        shouldCloseOnSelect={true}
                    />
                  </li>
              </ul>
              </React.Fragment>
            }
          </div> */}

          <div className="combinedUserFilter mt__1 animated fast pushUpSmall combinedSeparate">
          {
            Object.keys(combinedViewFilters).length < 1 ?
            <RoundImageLoader/>
            :
            userFilterOption?.AllUsers?.options && 
            <MultiOptionFilter 
              filterOptions={userFilterOption} 
              onClose={() => setUserFilter(false)} 
              showHeader={false} 
              onCheckChange={onApplyUsersFilter} 
              isOnlyOption={true} 
              isUsersFilter={true} 
              isParentCheckIcon={true}
            />
          }
          </div>
      </div>
    </div>
  )
}